import React, { lazy } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import Protectedroute from "./Redux/Protectedroute";
import PublicRoutesSuspense from "./Components/Layout/PublicRoutesSuspense";
import PrivateRoutesSuspense from "./Components/Layout/PrivateRoutesSuspense";
import "react-loading-skeleton/dist/skeleton.css";
import PageNotFound from "./pages/PageNotFound";
import ProtectPublic from "./Components/common/ProtectPublic";
import ParentProfile from "./pages/ParentProfile";
import Requests from "./pages/Requests";
const Login = lazy(() => import("./pages/Login"));
const ManageSchools = lazy(() => import("./pages/ManageSchools"));
const ManageOrganisationGroups = lazy(() =>
  import("./pages/ManageOrganisationGroups")
);
const OrganisationGroupDetail = lazy(() =>
  import("./pages/OrganisationGroupDetail")
);
const SchoolStats = lazy(() => import("./pages/SchoolStats"));
const Support = lazy(() => import("./pages/Support"));
const SupportDetail = lazy(() => import("./pages/SupportDetail"));
const Dashboard = lazy(() => import("./pages/Dashboard"));
const ManageTags = lazy(() => import("./pages/ManageTags"));
const ManagePresenters = lazy(() => import("./pages/ManagePresenters"));
const Teachers = lazy(() => import("./pages/Teachers"));
const PushNotifications = lazy(() => import("./pages/PushNotifications"));
const AddOnPacks = lazy(() => import("./pages/AddOnPacks/AddOnPacks"));
const PackDetail = lazy(() => import("./pages/AddOnPacks/PackDetails"));
const ChangePassword = lazy(() => import("./pages/ChangePassword"));
const ManageAdmins = lazy(() => import("./pages/ManageAdmins"));
const ManageContent = lazy(() => import("./pages/ManageContent"));
const Students = lazy(() => import("./pages/Students"));
const Parents = lazy(() => import("./pages/Parents"));
const Workers = lazy(() => import("./pages/Workers"));
const ManageCategories = lazy(() => import("./pages/ManageCategories"));
const ManageGroups = lazy(() => import("./pages/ManageGroups"));
const FAQs = lazy(() => import("./pages/FAQs"));
const UserContent = lazy(() => import("./pages/UserContent"));
const Opt = lazy(() => import("./pages/Opt"));
const SchoolProfile = lazy(() => import("./pages/SchoolProfile"));
const TeacherProfile = lazy(() => import("./pages/TeacherProfile"));
const SchoolAdminDetailPage = lazy(() =>
  import("./pages/SchoolAdminDetailPage")
);
const TeacherCollection = lazy(() => import("./pages/TeacherCollection"));
const StudentClassDetail = lazy(() => import("./pages/StudentClassDetail"));
const TeacherClassDetail = lazy(() => import("./pages/TeacherClassDetail"));
const StudentProfile = lazy(() => import("./pages/StudentProfile"));
const StudentCollection = lazy(() => import("./pages/StudentCollection"));
const ParentCollection = lazy(() => import("./pages/ParentCollection"));
const WorkerProfile = lazy(() => import("./pages/WorkerProfile"));
const AdminDetails = lazy(() => import("./pages/AdminDetails"));
const SingleVideo = lazy(() => import("./pages/SingleVideo"));
const UserContentVideoDetail = lazy(() => import("./pages/UserContentVideoDetail"));
const ForgotPassword = lazy(() => import("./pages/ForgetPassword"));
const ForgotOpt = lazy(() => import("./pages/ForgotOpt"));
const ResetPassword = lazy(() => import("./pages/ResetPassword"));
const AdminResetPassword = lazy(() => import("./pages/AdminResetPassword"));

function App() {

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<ProtectPublic />}>
            <Route
              path="/"
              element={
                <PublicRoutesSuspense>
                  {" "}
                  <Login />
                </PublicRoutesSuspense>
              }
            />
            <Route
              path="/admin-reset-password/:id"
              element={
                <PublicRoutesSuspense>
                  {" "}
                  <AdminResetPassword />
                </PublicRoutesSuspense>
              }
            />
            <Route
              path="/otp/:id"
              element={
                <PublicRoutesSuspense>
                  {" "}
                  <Opt />{" "}
                </PublicRoutesSuspense>
              }
            />
            <Route
              path="/forgot-opt/:id"
              element={
                <PublicRoutesSuspense>
                  <ForgotOpt />
                </PublicRoutesSuspense>
              }
            />
            <Route
              path="/reset-password/:id/:tokenid"
              element={
                <PublicRoutesSuspense>
                  <ResetPassword />
                </PublicRoutesSuspense>
              }
            />
            <Route
              path="/forgot-password"
              element={
                <PublicRoutesSuspense>
                  <ForgotPassword />
                </PublicRoutesSuspense>
              }
            />
          </Route>
          <Route element={<Protectedroute />}>
            <Route
              path="/manage-categories"
              element={
                <PrivateRoutesSuspense>
                  <ManageCategories />
                </PrivateRoutesSuspense>
              }
            />
            <Route
              path="/manage-groups"
              element={
                <PrivateRoutesSuspense>
                  <ManageGroups />
                </PrivateRoutesSuspense>
              }
            />
            <Route
              path="/students"
              element={
                <PrivateRoutesSuspense>
                  <Students />
                </PrivateRoutesSuspense>
              }
            />
            <Route
              path="/parents"
              element={
                <PrivateRoutesSuspense>
                  <Parents />
                </PrivateRoutesSuspense>
              }
            />
            <Route
              path="/workers"
              element={
                <PrivateRoutesSuspense>
                  <Workers />
                </PrivateRoutesSuspense>
              }
            />

            <Route
              path="/manage-schools"
              element={
                <PrivateRoutesSuspense>
                  <ManageSchools />
                </PrivateRoutesSuspense>
              }
            />
            <Route
              path="/manage-organisation-groups"
              element={
                <PrivateRoutesSuspense>
                  <ManageOrganisationGroups />
                </PrivateRoutesSuspense>
              }
            />
            <Route
              path="/organisation-group/:id"
              element={
                <PrivateRoutesSuspense>
                  <OrganisationGroupDetail />
                </PrivateRoutesSuspense>
              }
            />
            <Route
              path="/school-stats"
              element={
                <PrivateRoutesSuspense>
                  <SchoolStats />
                </PrivateRoutesSuspense>
              }
            />
            <Route
              path="/support"
              element={
                <PrivateRoutesSuspense>
                  <Support />
                </PrivateRoutesSuspense>
              }
            />
            <Route
              path="/support-detail/:id"
              element={
                <PrivateRoutesSuspense>
                  <SupportDetail />
                </PrivateRoutesSuspense>
              }
            />
            <Route
              path="/dashboard"
              element={
                <PrivateRoutesSuspense>
                  <Dashboard />
                </PrivateRoutesSuspense>
              }
            />
            <Route
              path="/teachers"
              element={
                <PrivateRoutesSuspense>
                  <Teachers />
                </PrivateRoutesSuspense>
              }
            />
            <Route
              path="/faqs"
              element={
                <PrivateRoutesSuspense>
                  {" "}
                  <FAQs />
                </PrivateRoutesSuspense>
              }
            />
            <Route
              path="/push-notifications"
              element={
                <PrivateRoutesSuspense>
                  <PushNotifications />
                </PrivateRoutesSuspense>
              }
            />
            <Route
              path="/strategy-packs"
              element={
                <PrivateRoutesSuspense>
                  <AddOnPacks />
                </PrivateRoutesSuspense>
              }
            />
            <Route
              path="/requests"
              element={
                <PrivateRoutesSuspense>
                  <Requests />
                </PrivateRoutesSuspense>
              }
            />
            <Route
              path="/pack-details/:id"
              element={
                <PrivateRoutesSuspense>
                  <PackDetail />
                </PrivateRoutesSuspense>
              }
            />
            <Route
              path="/change-password"
              element={
                <PrivateRoutesSuspense>
                  <ChangePassword />
                </PrivateRoutesSuspense>
              }
            />
            <Route
              path="/manage-admins"
              element={
                <PrivateRoutesSuspense>
                  <ManageAdmins />
                </PrivateRoutesSuspense>
              }
            />
            <Route
              path="/manage-content"
              element={
                <PrivateRoutesSuspense>
                  <ManageContent />
                </PrivateRoutesSuspense>
              }
            />
            <Route
              path="/user-content"
              element={
                <PrivateRoutesSuspense>
                  <UserContent />
                </PrivateRoutesSuspense>
              }
            />
            <Route
              path="/manage-tags"
              element={
                <PrivateRoutesSuspense>
                  <ManageTags />
                </PrivateRoutesSuspense>
              }
            />
            <Route
              path="/manage-presenters"
              element={
                <PrivateRoutesSuspense>
                  <ManagePresenters />
                </PrivateRoutesSuspense>
              }
            />
            <Route
              path="/school-profile/:id"
              element={
                <PrivateRoutesSuspense>
                  <SchoolProfile />
                </PrivateRoutesSuspense>
              }
            />
            <Route
              path="/teacher-profile/:id"
              element={
                <PrivateRoutesSuspense>
                  <TeacherProfile />
                </PrivateRoutesSuspense>
              }
            />
            <Route
              path="/school-admin-profile/:id"
              element={
                <PrivateRoutesSuspense>
                  <SchoolAdminDetailPage />
                </PrivateRoutesSuspense>
              }
            />
            <Route
              path="/teacher-collection/:id"
              element={
                <PrivateRoutesSuspense>
                  <TeacherCollection />
                </PrivateRoutesSuspense>
              }
            />
            <Route
              path="/student-class-detail/:id"
              element={
                <PrivateRoutesSuspense>
                  <StudentClassDetail />
                </PrivateRoutesSuspense>
              }
            />
            <Route
              path="/teacher-class-detail/:id"
              element={
                <PrivateRoutesSuspense>
                  <TeacherClassDetail />
                </PrivateRoutesSuspense>
              }
            />
            <Route
              path="/student-profile/:id"
              element={
                <PrivateRoutesSuspense>
                  <StudentProfile />
                </PrivateRoutesSuspense>
              }
            />
            <Route
              path="/parent-profile/:id"
              element={
                <PrivateRoutesSuspense>
                  <ParentProfile />
                </PrivateRoutesSuspense>
              }
            />
            <Route
              path="/worker-profile/:id"
              element={
                <PrivateRoutesSuspense>
                  <WorkerProfile />
                </PrivateRoutesSuspense>
              }
            />
            <Route
              path="/student-collection/:id"
              element={
                <PrivateRoutesSuspense>
                  <StudentCollection />
                </PrivateRoutesSuspense>
              }
            />
            <Route
              path="/parent-collection/:id"
              element={
                <PrivateRoutesSuspense>
                  <ParentCollection />
                </PrivateRoutesSuspense>
              }
            />
            <Route
              path="/admin-details/:id"
              element={
                <PrivateRoutesSuspense>
                  <AdminDetails />
                </PrivateRoutesSuspense>
              }
            />
            <Route
              path="/single-video/:id"
              element={
                <PrivateRoutesSuspense>
                  <SingleVideo />
                </PrivateRoutesSuspense>
              }
            />
            <Route
              path="/user-content-video/:id"
              element={
                <PrivateRoutesSuspense>
                  <UserContentVideoDetail />
                </PrivateRoutesSuspense>
              }
            />
          </Route>

          <Route path="*" element={<PageNotFound />} />
        </Routes>
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
